import React from "react";

import { EmblaCarouselType } from "embla-carousel/components/EmblaCarousel";

export interface PaginationProps {
  scrollSnaps: number[]; // or more specific type depending on the structure of scrollSnaps
  selectedIndex: number;
  onDotButtonClick?: (index: number) => void; // Making this optional
  emblaApi: EmblaCarouselType | undefined;
}

const Pagination: React.FC<PaginationProps> = ({
  scrollSnaps,
  selectedIndex,
  onDotButtonClick,
  emblaApi,
}) => {
  return (
    <div className="itens flex gap-10 xs:gap-0  w-max mt-4 mx-auto items-center">
      <div
        onClick={() => emblaApi && emblaApi.scrollPrev()}
        className="prev  transform rotate-[180deg]"
      >
        <NavigateIcon />
      </div>
      <div className="pagination flex items-center gap-2 xlg:gap-1 transition-all">
        {scrollSnaps.map((_, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                if (onDotButtonClick) {
                  onDotButtonClick(index); // Only call if onClick is provided
                }
              }}
            >
              {index === selectedIndex ? <Active /> : <Inactive />}
            </div>
          );
        })}
      </div>
      <div onClick={() => emblaApi && emblaApi.scrollNext()} className="next">
        <NavigateIcon />
      </div>
    </div>
  );
};

export default Pagination;

export const NavigateIcon = () => {
  return (
    <svg
      className="cursor-pointer xxs:!w-[60px]"
      width="98"
      height="98"
      viewBox="0 0 98 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1118_158653)">
        <rect x="25" y="23" width="48" height="48" rx="8" fill="white" />
        <path
          d="M43.3386 37.0235C43.2304 36.909 43.1459 36.7743 43.0897 36.6271C43.0336 36.4799 43.007 36.3231 43.0114 36.1657C43.0159 36.0082 43.0513 35.8532 43.1157 35.7094C43.18 35.5656 43.2721 35.4359 43.3866 35.3277C43.5011 35.2195 43.6358 35.1349 43.783 35.0788C43.9302 35.0226 44.087 34.996 44.2444 35.0005C44.4019 35.0049 44.557 35.0404 44.7007 35.1047C44.8445 35.1691 44.9742 35.2612 45.0824 35.3757L55.2764 46.1693C55.4869 46.392 55.6042 46.6868 55.6042 46.9933C55.6042 47.2997 55.4869 47.5945 55.2764 47.8172L45.0824 58.612C44.9749 58.729 44.8453 58.8235 44.701 58.89C44.5567 58.9565 44.4006 58.9936 44.2418 58.9992C44.083 59.0049 43.9247 58.9789 43.776 58.9229C43.6274 58.8668 43.4913 58.7818 43.3758 58.6727C43.2603 58.5636 43.1676 58.4326 43.1031 58.2874C43.0386 58.1422 43.0037 57.9857 43.0002 57.8268C42.9967 57.668 43.0249 57.51 43.083 57.3621C43.1411 57.2143 43.228 57.0794 43.3386 56.9654L52.7555 46.9933L43.3386 37.0235Z"
          fill="var(--primary-color)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1118_158653"
          x="0"
          y="0"
          width="98"
          height="98"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="12.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1118_158653"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1118_158653"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

const Active = () => {
  return (
    <svg
      className="xxs:!w-[20px] xxs:!h-[12px]"
      width="34"
      height="18"
      viewBox="0 0 34 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="33.5"
        y="17.5"
        width="33"
        height="17"
        rx="8.5"
        transform="rotate(-180 33.5 17.5)"
        stroke="var(--primary-color)"
      />
      <rect
        x="29"
        y="14"
        width="24"
        height="10"
        rx="5"
        transform="rotate(-180 29 14)"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

const Inactive = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="4" cy="4" r="4" fill="#A4A7B0" />
    </svg>
  );
};
